import { render } from "./BasicColumnChartDaily.vue?vue&type=template&id=4ea55ae2"
import script from "./BasicColumnChartDaily.vue?vue&type=script&lang=js"
export * from "./BasicColumnChartDaily.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__